import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  branchInfo: null,
  consultantId: null,
  email: null,
  id: null,
  role: null,
  branchLogo: null,
};

export const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInformation: (state, action) => {
      if (action?.payload?.branchInfo) {
        state.branchInfo = action.payload.branchInfo;
      }
      if (action?.payload?.consultantId) {
        state.consultantId = action.payload.consultantId;
      }

      if (action?.payload?.email) {
        state.email = action.payload.email;
      }
      if (action?.payload?.id) {
        state.id = action.payload.id;
      }
      if (action?.payload?.role) {
        state.role = action.payload.role;
      }
    },
    setBranchLogo: (state, action) => {
      state.branchLogo = action?.payload;
    },
  },
});

export const { setUserInformation, setBranchLogo } = UserSlice.actions;
export default UserSlice.reducer;
